<template>
  <div>
    <h2 class="title">集采活动</h2>
    <div class="collect_home">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        class="collect_tab"
      >
        <el-tab-pane
          :label="item.label"
          v-for="(item, index) in tabsList"
          :key="index"
          :name="item.activityProcess"
        >
          <div class="flex collect">
            <div
              class="collect_box"
              @click="onClickDetails(item.uuid, item)"
              v-for="(item, index) in collectList"
              :key="index"
            >
              <el-image class="collect_img" :src="item.coverUrl"></el-image>
              <div class="collect_iconBox">
                <el-image class="collect_icon" v-if="item.activityProcess == 'PROCESSING'" :src="require('../../assets/integral/underWay.jpg')"></el-image>
                <el-image class="collect_icon" v-if="item.activityProcess == 'PREPARING'" :src="require('../../assets/integral/jinxignzhong.jpg')"></el-image>
                <el-image class="collect_icon" v-if="item.activityProcess == 'FINISHED'" :src="require('../../assets/integral/ending.jpg')"></el-image>
                <p>{{ item.activityProcesseCn == '准备中'?item.activityProcesseCn ='即将开始' : item.activityProcesseCn }}</p>
              </div>
              <div class="collect_msg">
                <p class="collect_title">{{ item.activityName }}</p>
                <p class="collect_time">
                  {{ item.startTime }}—{{ item.endTime }}
                </p>
                <div class="flex collect_num">
                  <p><i class="el-icon-view"></i> 浏览 {{ item.viewNum? item.viewNum : 0  }}</p>
                  <p><i class="el-icon-goods"></i> 商品 {{ item.goodsNum? item.goodsNum : 0 }}</p>
                  <p><i class="el-icon-user"></i> 商家 {{ item.storeNum? item.storeNum : 0 }}</p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-pagination
        v-if="!noMsgShow"
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
      <div v-if="noMsgShow">
        <el-empty description="暂无集采活动" :image-size="100"></el-empty>
      </div>
    </div>

  </div>
</template>

<script>
import { collecQuery } from "../../utils/interface";
export default {
  data() {
    return {
      tabsList: [
        {
          label: "全部",
          activityProcess: ""
        },
        {
          label: "即将开始",
          activityProcess: "PREPARING"
        },
        {
          label: "活动中",
          activityProcess: "PROCESSING"
        },
        {
          label: "已结束",
          activityProcess: "FINISHED"
        },
      ],
      collectList: [],
      activeName: "",
      current: 1,
      pageSize: 10,
      total: 0,
      noMsgShow: false,
    };
  },
  mounted(){
    this.getCollecQuery();
  },
  methods: {
    handleClick() {
      this.getCollecQuery();
    },
    onClickDetails(uuid,item) {
      if(item.activityProcess == "PREPARING"){
        this.$message.warning(`活动筹备中，敬请期待~`)
      }else {
        let routeData = this.$router.resolve({
          name: "collectActivities",
          params: { uuid: uuid },
        });
        window.open(routeData.href, "_blank");
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      this.getCollecQuery();
    },
    getCollecQuery() {
      let param = {
        current: this.current,
        pageSize: this.pageSize,
        activityType: "CENTRAL",
        activityProcess: this.activeName == "0" ? "":this.activeName,
        survival: 'ENABLE',
      }
      collecQuery(param).then(res => {
        if(res.success){
          this.total = res.data.total;
          this.collectList = res.data.list;
          this.noMsgShow = false;
          if(res.data.list.length==0){
            this.noMsgShow = true;
          }
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.title {
  padding: 40px 30px;
  width: 1200px;
  margin: 0 auto;
}
/deep/ .el-tabs__item:hover {
  color: #1677ff;
}
/deep/.el-tabs__item {
  height: 60px;
  line-height: 78px;
}
/deep/ .el-tabs__item.is-active {
  color: #1677ff;
}

/deep/ .el-tabs__active-bar {
  background-color: #1677ff;
}
/deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}
/deep/.el-pagination {
  width: 1200px;
  margin: 0 auto;
  text-align: right;
}
/deep/.el-tabs__content {
  overflow: inherit;
}
.collect_home {
  background: #f5f7fa;
  padding-bottom: 40px;
  .collect_tab {
    width: 1200px;
    margin: 0 auto;
  }
  .collect {
    justify-content: space-between;
    flex-wrap: wrap;
    .collect_box {
      margin-bottom: 20px;
      position: relative;
      cursor: pointer;
      .collect_img {
        width: 590px;
        height: 300px;
        border-radius: 8px 8px 0 0;
        display: block;
      }
      .collect_iconBox {
        position: absolute;
        right: -10px;
        top: 20px;
        p {
          font-size: 14px;
          font-weight: 500;
          color: rgba(255,255,255,0.88);
          position: absolute;
          top: 25px;
          right: 17px;
        }
      }
      .collect_msg {
        background: #fff;
        width: 590px;
        box-sizing: border-box;
        border-radius: 0 0 8px 8px;
        padding: 20px;
        .collect_title {
          font-size: 16px;
          margin-bottom: 10px;
        }
        .collect_time {
          font-size: 14px;
          color: #6e6e6e;
          margin-bottom: 20px;
        }
        .collect_num {
          font-size: 12px;
          color: #6e6e6e;
          justify-content: space-between;
          border-top: 1px solid #6e6e6e4e;
          padding-top: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect/collectActivitiesHome.vue